/* Dabi Deri — uygulama modu ve mobil kabuk yardımcıları (docs/MOBIL.md). Masaüstünü değiştirmez.
   - html.is-standalone: "Ana ekrana ekle" ile açılan site (iOS / Android). Başlığa geri düğmesi, tepeden çekip yenileme.
   - Bağlantı koparsa üstte bildirim (telefonda ya da uygulama modunda).
   - Telefonda dokunmadan önce ön yükleme (Chrome: speculation rules) — masaüstünde eklenmez.
   - Manifest kısayolları: ?dabi=favs | more | search | categories → ilgili sekme / panel açılır.
   Metinler: <html data-app-*> (layout/theme.liquid, Tema ayarları → Uygulama modu). */
(() => {
  const html = document.documentElement;
  const mobile = window.matchMedia('(max-width: 749px)');
  const standalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  const isApp = standalone();
  if (isApp) html.classList.add('is-standalone');
  const L = html.dataset;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isHome = () => window.location.pathname === root || window.location.pathname === '/';

  /* ---------- geri düğmesi (uygulama modu, ana sayfa dışı) ---------- */
  if (isApp && !isHome()) {
    const head = document.querySelector('.dabi-header__grid');
    if (head && !head.querySelector('.dabi-appback')) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'dabi-appback';
      b.setAttribute('aria-label', L.appBack || 'Geri');
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>';
      b.addEventListener('click', () => {
        const sameOrigin = document.referrer && document.referrer.indexOf(window.location.origin) === 0;
        if (window.history.length > 1 && sameOrigin) window.history.back();
        else window.location.href = root;
      });
      head.insertBefore(b, head.firstChild);
      html.classList.add('has-appback');
    }
  }

  /* ---------- tepeden çekip yenile (uygulama modu; iOS'ta tarayıcı yenilemesi yok) ---------- */
  if (isApp) {
    const ptr = document.createElement('div');
    ptr.className = 'dabi-ptr';
    ptr.setAttribute('aria-hidden', 'true');
    ptr.innerHTML = '<span class="dabi-ptr__ico"><svg viewBox="0 0 24 24" focusable="false"><path d="M20 12a8 8 0 1 1-2.3-5.7"/><path d="M20 4v4.5h-4.5"/></svg></span>';
    document.body.appendChild(ptr);
    const LIMIT = 86;
    let y0 = null;
    let pull = 0;
    const blocked = () => html.classList.contains('is-dabi-sheet') || html.classList.contains('dabi-tabsheet-open')
      || !!document.querySelector('cart-drawer.active, details[open] > .dabi-header__drawer, [data-qv-modal][open], .dabi-col__favs:not([hidden])');
    window.addEventListener('touchstart', (e) => {
      if (window.scrollY > 0 || e.touches.length !== 1 || blocked()) { y0 = null; return; }
      y0 = e.touches[0].clientY;
      pull = 0;
    }, { passive: true });
    window.addEventListener('touchmove', (e) => {
      if (y0 === null) return;
      pull = Math.max(0, e.touches[0].clientY - y0);
      if (window.scrollY > 0) pull = 0;
      const p = Math.min(1, pull / LIMIT);
      ptr.style.setProperty('--p', p.toFixed(3));
      ptr.classList.toggle('is-pulling', pull > 6);
      ptr.classList.toggle('is-ready', pull >= LIMIT);
    }, { passive: true });
    window.addEventListener('touchend', () => {
      if (y0 === null) return;
      y0 = null;
      if (pull >= LIMIT) {
        ptr.classList.add('is-loading');
        try { if (navigator.vibrate) navigator.vibrate(10); } catch (err) { /* yok */ }
        window.setTimeout(() => window.location.reload(), 120);
        return;
      }
      ptr.classList.remove('is-pulling', 'is-ready');
      ptr.style.setProperty('--p', '0');
    }, { passive: true });
  }

  /* ---------- bağlantı koptu ---------- */
  let offBar = null;
  const showOffline = (off) => {
    if (!mobile.matches && !isApp) return;
    if (off) {
      if (!offBar) {
        offBar = document.createElement('div');
        offBar.className = 'dabi-offline';
        offBar.setAttribute('role', 'status');
        offBar.innerHTML = '<span></span><button type="button"></button>';
        offBar.querySelector('span').textContent = L.appOffline || 'Bağlantı yok';
        const retry = offBar.querySelector('button');
        retry.textContent = L.appRetry || 'Tekrar dene';
        retry.addEventListener('click', () => window.location.reload());
        document.body.appendChild(offBar);
      }
      window.setTimeout(() => offBar && offBar.classList.add('is-on'), 20);
    } else if (offBar) {
      offBar.classList.remove('is-on');
    }
  };
  window.addEventListener('offline', () => showOffline(true));
  window.addEventListener('online', () => showOffline(false));
  if (navigator.onLine === false) showOffline(true);

  /* ---------- ön yükleme (yalnız telefon / uygulama; Chrome speculation rules) ---------- */
  if ((mobile.matches || isApp) && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
    const rules = {
      prefetch: [{
        source: 'document',
        where: { and: [
          { href_matches: '/*' },
          { not: { href_matches: ['/cart*', '/checkout*', '/checkouts/*', '/account*', '/*/cart*', '/*/account*'] } },
          { not: { selector_matches: '[rel~=nofollow], [target=_blank], [data-no-prefetch]' } },
        ] },
        eagerness: 'moderate',
      }],
    };
    const s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify(rules);
    document.head.appendChild(s);
  }

  /* ---------- mobil menü: hızlı düğmeler ---------- */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-mm-act]');
    if (!a) return;
    if (a.dataset.mmAct === 'favs' && window.DabiTabbar && document.documentElement.classList.contains('has-dabi-tabbar')) {
      e.preventDefault();
      const d = a.closest('details[open]');
      if (d) { const s = d.querySelector(':scope > summary'); if (s) s.click(); else d.open = false; }
      window.setTimeout(() => window.DabiTabbar.open('fav'), 120);
    }
  });

  /* ---------- manifest kısayolları ---------- */
  const want = new URLSearchParams(window.location.search).get('dabi');
  if (want) {
    const go = () => {
      const tab = { favs: 'favorites', more: 'more', search: 'search', categories: 'categories' }[want];
      const el = tab && document.querySelector(`.dabi-tabbar [data-tab="${tab}"]`);
      if (el) el.click();
      else if (want === 'search') { const d = document.querySelector('.dabi-search > details summary'); if (d) d.click(); }
    };
    if (document.readyState === 'complete') window.setTimeout(go, 300); else window.addEventListener('load', () => window.setTimeout(go, 300));
  }
})();
